import { createStateSelectorHook } from 'src/lib/sweetState';

import { DocumentViewStore, GenerationStore } from '../store';

const useDocumentState = createStateSelectorHook(DocumentViewStore, ['generating']);

const useGenerationState = createStateSelectorHook(GenerationStore, ['generating']);

// HINT: currently we have "generating" state in two stores,
// but we want to migrate all generation logic into GenerationStore eventually
export const useIsGenerating = () => {
  const documentState = useDocumentState();
  const generationState = useGenerationState();
  return generationState.generating || documentState.generating;
};
